module.exports = __webpack_public_path__ + "img/strategies_walkaway.37fb31f9.png";